<mat-toolbar class="main-header">
  <!-- <button class="sidebar-toggle-btn" (click)="toggleSidebar()" aria-label="Toggle sidebar">
    <mat-icon style="color: #fff;">arrow_back_ios</mat-icon>
  </button> -->
  <!-- Logo and App Name -->
  <div class="logo-section">
    <!-- <div class="">
      <mat-icon style="color: #000; align-items: center; display: flex;cursor: pointer; "
        routerLink="/templates">arrow_back</mat-icon>

    </div> -->
    <div class="logo-icon">
      <mat-icon (click)="toggleSidebar()" style="cursor: pointer;">menu</mat-icon>
    </div>
    <span class="app-name">Otter AI</span>


    <!-- Interview Code -->
    <div class="interview-code desktop-only">
      <span>Interview Code:</span>
      <span class="code">{{templateId}}</span>
      <mat-icon class="mat-icon-copy" [class.animate-copied]="templateId" (click)="copyCode()"
        matTooltip="{{ copied ? 'Copied!' : 'Copy link' }}">
        {{ copied ? 'check_circle' : 'content_copy' }}
      </mat-icon>
    </div>
  </div>
  <!-- Spacer -->
  <span class="spacer"></span>

  <!-- Action Buttons (Desktop and Large Screen) -->
  <div class="action-buttons">
    <!-- header.component.html -->
    <div class="zoom-controls">
      <button class="zoom-btn" (click)="onZoomIn()">+</button>
      <button class="zoom-btn" (click)="onZoomOut()">−</button>
    </div>


    <button class="purple" (click)="newInterview()">
      <mat-icon>group_outline</mat-icon>
      New Interview
    </button>
    <button class="warn" (click)="signOut()">
      <mat-icon>logout</mat-icon>
      Logout
    </button>
  </div>

  <!-- Mobile Menu Toggle (Hamburger) -->

  <mat-icon class="mobile-menu-toggle" style="color: #000;" (click)="toggleMenu()">more_vert

  </mat-icon>


  <!-- Mobile Dropdown Menu -->
  <div *ngIf="menuOpen" class="mobile-menu">
    <div class="zoom-controls">
      <button class="zoom-btn" (click)="onZoomIn()">+</button>
      <button class="zoom-btn" (click)="onZoomOut()">−</button>
    </div>
    <div class="interview-code">
      <span>Code:</span>
      <span class="code">{{templateId}}</span>
      <mat-icon class="mat-icon-copy" [class.animate-copied]="templateId" (click)="copyCode()"
        matTooltip="{{ copied ? 'Copied!' : 'Copy link' }}">
        {{ copied ? 'check_circle' : 'content_copy' }}
      </mat-icon>
    </div>
    <button (click)="newInterview()">New Interview</button>
    <button (click)="signOut()">Logout</button>
  </div>
</mat-toolbar>